<div
  class="pu-form-container"
  [formGroup]="form()"
>
  <div
    class="pu-form-container"
    formGroupName="delivery"
  >
    <div class="pu-form-group">
      <pu-simple-input
        formControlName="country"
        [isReadonly]="true"
        [label]="'deliveryForm.input.country*' | translate"
      />

      <pu-simple-input
        formControlName="postcode"
        [controlType]="controlTypes.Number"
        [label]="'deliveryForm.input.postcode*' | translate"
      />
    </div>

    <div class="pu-form-group">
      <pu-simple-input
        formControlName="regionState"
        [label]="'deliveryForm.input.regionState' | translate"
      />

      <pu-simple-input
        formControlName="city"
        [label]="'deliveryForm.input.city*' | translate"
      />
    </div>

    <pu-simple-input
      formControlName="address"
      [label]="'deliveryForm.input.address*' | translate"
    />

    <div class="pu-form-group">
      <pu-simple-input
        formControlName="apartment"
        [label]="'deliveryForm.input.apartment' | translate"
      />

      <pu-simple-input
        formControlName="email"
        [label]="'deliveryForm.input.email*' | translate"
      />
    </div>
  </div>
</div>
